// extracted by mini-css-extract-plugin
export default {"root":"UnsavedChangesModal__root--35dBo","description":"UnsavedChangesModal__description--3eCiM"};